/**
 * Filters form data to exclude content-related fields, keeping only preferences
 * that should be saved for future use.
 */
export function filterFormPreferences<T extends Record<string, any>>(
  formData: T,
  excludeFields: string[] = []
): Partial<T> {
  const defaultExcludedFields = [
    'subject',
    'files',
    'fileUrls',
    'attachments',
    // Add other content fields that shouldn't be saved as defaults
  ];

  const fieldsToExclude = [...defaultExcludedFields, ...excludeFields];

  const filtered: Partial<T> = {};

  for (const [key, value] of Object.entries(formData)) {
    if (!fieldsToExclude.includes(key)) {
      filtered[key as keyof T] = value;
    }
  }

  return filtered;
}
